<!-- FOOTER PARTIAL -->
<footer class="footer footer__wrapper" *ngIf="showDefaultFooter">
  <div class="container-fluid">
    <div class="row__default">
      <div class="footer__container">
        <div class="footer__content"
             [ngClass]="{'pdd__mobile': isExtendedPadding}">
          <div class="justify-content-center">
            <p class="copyright">
              <!-- © 2017 Westgate Cruise & Travel Collection. All rights reserved. Privacy Policy - -->
              {{displayOptions?.labels?.copyright}} -
              <!-- <a href="#">Privacy Rights</a> | <a href="#">Terms of Use</a> -->
              <span *ngFor="let f of displayOptions?.footers; let i = index">
                <a [href]="f.link_href | safeUrl" target="_blank" rel="noreferrer">
                  {{f.text_link}}
                </a>
                <span *ngIf="i !== displayOptions?.footers?.length - 1"> | </span>
              </span>
            </p>
          </div><!-- end row -->
        </div><!-- end content -->
      </div>
    </div><!-- end container -->
  </div><!-- end container-fluid -->
</footer><!-- end wrapper -->
<footer class="sor-footer" *ngIf="showSorFooter">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="footer-border">
          <div class="footer-links sor-footer">
            <ul class="footer-links-list">
              <li *ngFor="let item of footersItems">
                <a href="{{item.link_href}}" target="_blank" rel="noopener noreferrer">{{item.text_link}}</a>
              </li>
            </ul>
            <ul class="copyright footer-links-list">
              <li *ngFor="let item2 of footersCopyrights" class="copyright-list">
                <a href="{{item2.link_href}}" target="_blank" rel="noopener noreferrer" [innerHTML]="item2.text_link"></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

<!-- FOOTER PARTIAL END -->
<!-- DEV MODE NAVIGATION -->
<!-- <div class="dev__bar">
  <div class="container-fluid">
    <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">PAGES</a>
    <ul class="dropdown-menu">
      <li><a routerLink="/payment-method" routerLinkActive="active">Payment method</a></li>
      <li><a routerLink="/cars" routerLinkActive="active">Search results</a></li>
      <li><a routerLink="/review" routerLinkActive="active">Review</a></li>
      <li><a routerLink="/reservation" routerLinkActive="active">Reservation</a></li>
      <li><a routerLink="/confirmation/4324234" routerLinkActive="active">Confirmation</a></li>
      <li><a routerLink="/cancellation/4324234" routerLinkActive="active">Cancellation</a></li>
      <li><a routerLink="/emails" routerLinkActive="active">Emails</a></li>
    </ul>
  </div>
</div> -->
<!-- DEV MODE NAVIGATION END -->
